import * as React from 'react';
import { Image, RoundButton } from '@cian/ui-kit';
import { IconActionClose16, IconToggleHeartOff16, IconToggleHeartOn16 } from '@cian/ui-kit-design-tokens/icons';

import * as style from './Photo.css';

export interface IPhotoProps {
  imageUrl: string;
  name: string;
  isFavorite: boolean;
}

export const Photo = ({ imageUrl, name, isFavorite }: IPhotoProps): React.JSX.Element => (
  <div className={style['container']}>
    <Image alt={name} borderRadius="16px" height={200} objectFit="cover" src={imageUrl} width="100%" />
    <div className={style['actions']}>
      {/* TODO: удаление из сравнения */}
      <RoundButton icon={<IconActionClose16 />} size="M" theme="light" title="Удалить из сравнения" />
      {/* TODO: добавление/удаление из избранного */}
      <RoundButton
        icon={isFavorite ? <IconToggleHeartOn16 /> : <IconToggleHeartOff16 />}
        size="M"
        theme="light"
        title="В избранное"
      />
    </div>
  </div>
);
